import { Injectable } from '@angular/core';

import { FormaControle } from "./forma-controle.model";
import { apiName } from "./data.service";
import { RestService } from "../../../core/services/rest.service";

@Injectable()
export class FormaControleApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: FormaControle, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: FormaControle, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"formaControle","where":{"ativo":true}};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGetPostId(apiName, objectId, {}, done);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/formas-controle/shared/forma-controle-api.service.ts
 **/